var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 28,
    viewBox: "0 0 162 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.8886 23.026C58.1918 23.061 58.495 23.0901 58.801 23.0901C59.1275 23.0901 59.454 23.0639 59.7776 23.0144C62.8939 22.5337 65.2173 19.8276 65.2173 16.6787V9.25936C65.2173 9.17489 65.1473 9.10498 65.0628 9.10498H62.308C62.2234 9.10498 62.1535 9.17489 62.1535 9.25936V16.6816C62.1535 18.2429 61.0574 19.6062 59.5327 19.9499C59.2937 20.0053 59.0459 20.0315 58.801 20.0315C58.4162 20.0315 57.979 19.9295 57.979 19.9295C56.501 19.5538 55.4486 18.208 55.4486 16.6845V9.25936C55.4486 9.17489 55.3787 9.10498 55.2941 9.10498H52.5393C52.4548 9.10498 52.3848 9.17489 52.3848 9.25936V16.6816C52.3848 19.5916 54.3759 22.1579 57.1948 22.8891C57.1948 22.8891 57.5592 22.9911 57.8886 23.0289V23.026Z",
    fill: "url(#paint0_linear_2186_3570)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.589 8.09084C140.697 8.09084 137.4 10.9921 136.925 14.8547C136.887 15.1722 136.866 15.4898 136.866 15.8102C136.866 15.8597 136.866 15.9092 136.866 15.9558V22.9382C136.866 23.0227 136.936 23.0926 137.021 23.0926H139.776C139.86 23.0926 139.93 23.0227 139.93 22.9382V15.9617C139.93 15.9121 139.93 15.8626 139.93 15.8102C139.93 15.5538 139.951 15.2946 139.994 15.0412C140.367 12.7982 142.318 11.1524 144.591 11.1524H145.093C145.177 11.1524 145.247 11.0824 145.247 10.998V8.24523C145.247 8.16075 145.177 8.09084 145.093 8.09084H144.589Z",
    fill: "url(#paint1_linear_2186_3570)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.233 7.9538C154.916 7.91593 154.598 7.89554 154.277 7.89554C153.957 7.89554 153.639 7.91593 153.321 7.9538C149.456 8.43153 146.555 11.7232 146.555 15.612C146.555 19.5008 149.458 22.7953 153.321 23.2701C153.639 23.308 153.957 23.3284 154.277 23.3284C154.598 23.3284 154.916 23.308 155.233 23.2701C159.099 22.7924 161.999 19.5008 161.999 15.612C161.999 11.7232 159.096 8.42861 155.233 7.9538ZM155.047 20.2057C154.793 20.2465 154.537 20.2698 154.277 20.2698C154.018 20.2698 153.761 20.2494 153.508 20.2057L153.443 20.1941C151.228 19.7979 149.619 17.8579 149.619 15.612C149.619 13.3661 151.266 11.3911 153.51 11.0182C153.764 10.9775 154.021 10.9541 154.28 10.9541C154.54 10.9541 154.796 10.9745 155.05 11.0182L155.111 11.027C157.326 11.4231 158.941 13.3632 158.941 15.6091C158.941 17.8549 157.294 19.8299 155.05 20.2028L155.047 20.2057Z",
    fill: "url(#paint2_linear_2186_3570)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.344 8.13775C107.531 8.13775 105.811 8.90969 104.595 10.2497C104.56 10.2875 104.514 10.3079 104.461 10.3079C104.409 10.3079 104.362 10.2875 104.327 10.2497C103.111 8.90969 101.388 8.13775 99.5782 8.13775C96.0479 8.13775 93.162 11.0216 93.162 14.5492V22.9356C93.162 23.0201 93.2319 23.09 93.3165 23.09H96.0713C96.1558 23.09 96.2258 23.0201 96.2258 22.9356V14.5492C96.2258 12.7082 97.7358 11.1993 99.5782 11.1993C101.421 11.1993 102.931 12.7082 102.931 14.5492V22.9356C102.931 23.0201 103.001 23.09 103.085 23.09H105.84C105.924 23.09 105.994 23.0201 105.994 22.9356V14.5492C105.994 12.7082 107.504 11.1993 109.347 11.1993C111.189 11.1993 112.699 12.7082 112.699 14.5492V22.9356C112.699 23.0201 112.769 23.09 112.854 23.09H115.609C115.693 23.09 115.763 23.0201 115.763 22.9356V14.5492C115.763 11.0216 112.877 8.13775 109.347 8.13775H109.344Z",
    fill: "url(#paint3_linear_2186_3570)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5956 3.82045H68.8408C68.7555 3.82045 68.6863 3.88957 68.6863 3.97483V22.9353C68.6863 23.0205 68.7555 23.0897 68.8408 23.0897H71.5956C71.6809 23.0897 71.7501 23.0205 71.7501 22.9353V3.97483C71.7501 3.88957 71.6809 3.82045 71.5956 3.82045Z",
    fill: "url(#paint4_linear_2186_3570)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.9185 3.82045H46.1637C46.0792 3.82045 46.0092 3.89036 46.0092 3.97483V11.9243H35.6634V3.97483C35.6634 3.89036 35.5935 3.82045 35.5089 3.82045H32.7541C32.6696 3.82045 32.5996 3.89036 32.5996 3.97483V22.9353C32.5996 23.0198 32.6696 23.0897 32.7541 23.0897H35.5089C35.5935 23.0897 35.6634 23.0198 35.6634 22.9353V14.9858H46.0092V22.9353C46.0092 23.0198 46.0792 23.0897 46.1637 23.0897H48.9185C49.0031 23.0897 49.0731 23.0198 49.0731 22.9353V3.97483C49.0731 3.89036 49.0031 3.82045 48.9185 3.82045Z",
    fill: "url(#paint5_linear_2186_3570)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.823 7.9538C127.505 7.91593 127.187 7.89554 126.867 7.89554C126.546 7.89554 126.228 7.91593 125.91 7.9538C122.045 8.43153 119.144 11.7232 119.144 15.612V27.2492C119.144 27.3337 119.214 27.4036 119.299 27.4036H122.054C122.138 27.4036 122.208 27.3337 122.208 27.2492V15.6149C122.208 13.3428 123.855 11.394 126.1 11.0211C126.354 10.9804 126.61 10.9571 126.869 10.9571C127.129 10.9571 127.385 10.9775 127.639 11.0211L127.7 11.0299C129.916 11.426 131.531 13.3661 131.531 15.612C131.531 17.8579 129.884 19.8328 127.639 20.2057C127.385 20.2465 127.129 20.2698 126.869 20.2698C126.61 20.2698 126.354 20.2494 126.1 20.2057L126.036 20.1941C125.316 20.0659 124.636 19.7659 124.056 19.3231C124.007 19.2852 123.949 19.2794 123.893 19.3085C123.838 19.3347 123.806 19.3843 123.806 19.4483V22.5972C123.806 22.6642 123.841 22.7167 123.902 22.74C124.546 23.008 125.222 23.1857 125.913 23.2701C126.231 23.308 126.549 23.3284 126.869 23.3284C127.19 23.3284 127.508 23.308 127.826 23.2701C131.691 22.7924 134.592 19.5008 134.592 15.612C134.592 11.7232 131.688 8.42861 127.826 7.9538H127.823Z",
    fill: "url(#paint6_linear_2186_3570)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.0371 7.9538C82.7193 7.91593 82.3986 7.89554 82.0809 7.89554C81.7631 7.89554 81.4425 7.91593 81.1247 7.9538C77.2593 8.43153 74.3587 11.7232 74.3587 15.612C74.3587 19.5008 77.2622 22.7953 81.1247 23.2701C81.4425 23.308 81.7602 23.3284 82.0809 23.3284C82.4016 23.3284 82.7193 23.308 83.0371 23.2701C83.7279 23.1857 84.4043 23.008 85.0485 22.74C85.1097 22.7138 85.1447 22.6613 85.1447 22.5972V19.4483C85.1447 19.3872 85.1156 19.3376 85.0572 19.3085C85.0019 19.2823 84.9436 19.2852 84.894 19.3231C84.2935 19.7775 83.5939 20.0805 82.8476 20.2028C82.594 20.2436 82.3374 20.2669 82.078 20.2669C81.8185 20.2669 81.562 20.2465 81.3084 20.2028L81.2443 20.1911C79.0287 19.795 77.4196 17.8549 77.4196 15.6091C77.4196 13.3632 79.0666 11.3882 81.3113 11.0153C81.5649 10.9745 81.8214 10.9512 82.0809 10.9512C82.3403 10.9512 82.5969 10.9716 82.8505 11.0153L82.9117 11.0241C85.1272 11.4202 86.7422 13.3603 86.7422 15.6061V22.9264C86.7422 23.0109 86.8122 23.0808 86.8967 23.0808H89.6515C89.736 23.0808 89.806 23.0109 89.806 22.9264V15.6061C89.806 11.7173 86.9025 8.42279 83.04 7.94797L83.0371 7.9538Z",
    fill: "url(#paint7_linear_2186_3570)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.86806 1.07374C6.25588 0.773705 5.55625 0.593102 4.87119 0.593102C2.18052 0.593102 0 2.772 0 5.46066V21.4499C0 24.1386 2.18052 26.3174 4.87119 26.3174C7.56187 26.3174 9.74239 24.1386 9.74239 21.4499V8.07649L15.5989 4.6392L6.86806 1.07374Z",
    fill: "url(#paint8_linear_2186_3570)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.474 25.8368C19.0861 26.1368 19.7858 26.3174 20.4708 26.3174C23.1615 26.3174 25.342 24.1386 25.342 21.4499V5.46066C25.342 2.772 23.1615 0.593102 20.4708 0.593102C17.7802 0.593102 15.5996 2.772 15.5996 5.46066V18.8341L9.74313 22.2713L18.474 25.8397V25.8368Z",
    fill: "url(#paint9_linear_2186_3570)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2186_3570",
    x1: 32.5996,
    y1: 3.82045,
    x2: 42.0076,
    y2: 49.8765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3478D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A67BED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2186_3570",
    x1: 32.5996,
    y1: 3.82045,
    x2: 42.0076,
    y2: 49.8765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3478D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A67BED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2186_3570",
    x1: 32.5996,
    y1: 3.82045,
    x2: 42.0076,
    y2: 49.8765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3478D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A67BED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2186_3570",
    x1: 32.5996,
    y1: 3.82045,
    x2: 42.0076,
    y2: 49.8765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3478D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A67BED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2186_3570",
    x1: 32.5996,
    y1: 3.82045,
    x2: 42.0076,
    y2: 49.8765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3478D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A67BED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2186_3570",
    x1: 32.5996,
    y1: 3.82045,
    x2: 42.0076,
    y2: 49.8765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3478D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A67BED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2186_3570",
    x1: 32.5996,
    y1: 3.82045,
    x2: 42.0076,
    y2: 49.8765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3478D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A67BED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2186_3570",
    x1: 32.5996,
    y1: 3.82045,
    x2: 42.0076,
    y2: 49.8765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3478D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A67BED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2186_3570",
    x1: 0,
    y1: 0.593102,
    x2: 25.9506,
    y2: 23.402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3478D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A67BED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2186_3570",
    x1: 0,
    y1: 0.593102,
    x2: 25.9506,
    y2: 23.402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3478D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A67BED"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.cf0c504eb7cd544b46e1ecd1cf9abb07.svg";
export { ForwardRef as ReactComponent };